// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__19dkl","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1zkVx"};